export type IMaskDecimalFields = IDCA.IGenericFunc;

export function _maskDecimalFields(): void {
  $('input.decimal-field').each((_, elm) => {
    const $elm = $(elm);
    const precisionNum = !Number.isNaN(Number($elm.data('precision')))
      ? Number($elm.data('precision'))
      : 0;
    ($elm as any).maskMoney({
      allowNegative: true,
      allowZero: true,
      decimal: '.',
      precision: precisionNum,
      thousands: '',
    });
  });
}
